export const message = `
Dear Senator, 

I am a concerned citizen of your constituent, and I'll like to express my
displeasure about SARS. The members of this squad who are supposed to
protect us against armed robbery are killing, extorting and harassing us
everyday. We are scared to move freely and we need your help. I urge you,
distinguished, to use your office to protect the lives of Nigerian youth and
the future of Nigeria. We are counting on you to do the right thing. We are
counting on you to help us #ENDSARS #ENDPOLICEBRUTALITY.

Thanks, Senator!
`;
